import { render, staticRenderFns } from "./JiuZheng.vue?vue&type=template&id=0af5d8c4&scoped=true"
import script from "./JiuZheng.vue?vue&type=script&lang=js"
export * from "./JiuZheng.vue?vue&type=script&lang=js"
import style0 from "./JiuZheng.vue?vue&type=style&index=0&id=0af5d8c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5d8c4",
  null
  
)

export default component.exports